import posthog from 'posthog-js'
import { router } from '@inertiajs/react'

const key  = process.env.MIX_POSTHOG_KEY
const keyStudio  = process.env.MIX_POSTHOG_KEY_STUDIO
const keyCms  = 'phc_XMqy0kKoBh9ACJbasDWCfKzIJJKnZNRRlc3DQkRkdWg';
const host = process.env.MIX_POSTHOG_HOST || 'https://eu.posthog.com'

const isLocal = typeof window !== 'undefined' && /^(localhost|127\.0\.0\.1)/.test(window.location.hostname)

if (key && !isLocal) {

  const isStudioDomain =
  typeof window !== 'undefined' &&
  /^studio\./.test(window.location.hostname);

  const isCmsDomain =
  typeof window !== 'undefined' &&
  /^cms\./.test(window.location.hostname);

  const selectedKey = isStudioDomain ? keyStudio : isCmsDomain ? keyCms : key;

  posthog.init(selectedKey, {
    api_host: host,
    autocapture: true,
    capture_pageview: false,            
    capture_pageleave: true,
    disable_session_recording: false,
    session_recording: {
      maskTextSelector: 'input[type="password"], [data-ph-mask]'
    },
    persistence: 'localStorage+cookie',
  })

  if (typeof window !== 'undefined') (window).posthog = posthog

  router.on('navigate', () => {
    posthog.capture('$pageview', {
      $current_url: window.location.href,
      path: window.location.pathname + window.location.search,
    })
  })

  if (typeof window !== 'undefined') {
    posthog.capture('$pageview', {
      $current_url: window.location.href,
      path: window.location.pathname + window.location.search,
    })
  }

  try {
    const user = (window)?.Laravel?.user || (window)?.__INITIAL_USER__
    if (user?.id) {
      posthog.identify(String(user.id), {
        email: user.email,
        name: user.name,
        role: user.role,
      })
    }
  } catch {}

} else {
  console.warn('[PostHog] MIX_POSTHOG_KEY not set or running on localhost — analytics disabled')
}

export default posthog
